const Layout2Settings = {
  mode: 'contained', // boxed | contained | full
  topbar: {
    show: true,
    fixed: true,
    theme: 'blue'
  },
  navbar: {
    show: true,
    theme: 'blue'
  },
  leftSidebar: { // Only for mobile devices
    show: true,
    mode: 'close', // full | close | compact | mobile
    theme: 'blue'
  }
}

export default Layout2Settings;